import { constantRoutes } from '@/router'
import Layout from '@/layout/index.vue'
// const Layout=await import('@/layout/index.vue')
import ParentView from '@/components/ParentView/index.vue'
import { toCamelCase } from '@/utils'

const permission = {
    state: {
        routes: [],
        addRoutes: [],
        sidebarRouters: [], // 左侧边菜单的路由，被 Sidebar/index.vue 使用
    },
    mutations: {
        SET_ROUTES: (state, routes) => {
            state.addRoutes = routes
            state.routes = constantRoutes.concat(routes)
        },
        SET_DEFAULT_ROUTES: (state, routes) => {
            state.defaultRoutes = constantRoutes.concat(routes)
        },
        SET_SIDEBAR_ROUTERS: (state, routes) => {
            state.sidebarRouters = routes
        }
    },
    actions: {
        // 生成路由
        GenerateRoutes({ commit },data) {
            return new Promise((resolve) => {
                    const sdata = JSON.parse(JSON.stringify([])) // 【重要】用于菜单中的数据
                    const rdata = JSON.parse(JSON.stringify([])) // 用于最后添加到 Router 中的数据
                    const sidebarRoutes = filterAsyncRouter(sdata)
                    const rewriteRoutes = filterAsyncRouter(rdata, false, true)
                    rewriteRoutes.push({ path: '*', redirect: '/404', hidden: true })
                    commit('SET_ROUTES', rewriteRoutes)
                    commit('SET_SIDEBAR_ROUTERS', constantRoutes.concat(sidebarRoutes))
                    dealrouter(dealmenuIds(data.menuIds),constantRoutes)
                    commit('SET_DEFAULT_ROUTES', sidebarRoutes)
                    resolve(rewriteRoutes)
            })
        }
    }
}

function dealmenuIds(array){
    let returnArr=[];
    for (let i = 0; i < array.length; i++) {
        if (array[i]) { 
            if (array[i].split(",").length>0) {
                returnArr=[...array[i].split(","),...returnArr]
            }else{
                returnArr.concat([],...returnArr)
            }
        }
    }
    return [...new Set(returnArr)];
}

function dealrouter(authMenuIds,routerList){
    for (let a = 0;a < authMenuIds.length; a++) {
        for (let i = 0; i < routerList.length; i++) {
            if (authMenuIds[a]==routerList[i]['id']) {
                routerList[i]['auth']=true;
            }
            if (routerList[i]['children']&&routerList[i]['children'].length>0) {
                dealrouter(authMenuIds,routerList[i]['children'])
            }
        } 
    }

    return routerList;
}

// 遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, lastRouter = false, type = false) {
    return asyncRouterMap.filter((route) => {
        // 处理 meta
        route.meta = {
            title: route.name,
            icon: route.icon,
            noCache: !route.keepAlive
        }
        // 路由地址转首字母大写驼峰，作为路由名称，适配 keepAlive
        route.name = toCamelCase(route.path, true)
        route.hidden = !route.visible
        // 处理 component 属性
        if (route.children) {
            // 父节点
            if (route.parentId === 0) {
                route.component = Layout
            } else {
                route.component = ParentView
            }
        } else {
            // 根节点
            route.component = loadView(route.component)
        }

        // filterChildren
        if (type && route.children) {
            route.children = filterChildren(route.children)
        }
        if (route.children != null && route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children, route, type)
        } else {
            delete route['children']
        }
        return true
    })
}

function filterChildren(childrenMap, lastRouter = false) {
    let children = []
    childrenMap.forEach((el, index) => {
        if (el.children && el.children.length) {
            if (el.component === 'ParentView' && !lastRouter) {
                el.children.forEach((c) => {
                    c.path = el.path + '/' + c.path
                    if (c.children && c.children.length) {
                        children = children.concat(filterChildren(c.children, c))
                        return
                    }
                    children.push(c)
                })
                return
            }
        }
        if (lastRouter) {
            el.path = lastRouter.path + '/' + el.path
        }
        children = children.concat(el)
    })
    return children
}

export const loadView = (view) => {
    // 路由懒加载
    return (resolve) => {
        return require([`@/views/${view}`], resolve)
    }
}

export default permission
